import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/Auth";
import { useData } from "../context/Data";
import { api } from "../lib/api";
import { BrandMark, WaFloat, LegalLinks } from "./common";
import { todayLabel, wa, dateTime, WA_DISPLAY } from "../lib/fmt";

export const NAV = [
  ["inicio", "⌂", "Inicio"], ["misiones", "🎯", "Misiones"], ["premios", "🎁", "Premios"], ["vip", "💎", "VIP"],
  ["actividades", "🎮", "Actividades"], ["referidos", "👥", "Referidos"], ["ranking", "🏆", "Ranking"],
  ["estadisticas", "📊", "Estadísticas"], ["cartera", "💰", "Cartera"], ["retiradas", "💸", "Retiradas"], ["ayuda", "💬", "Ayuda"],
];

function Notifications() {
  const { d, load } = useData();
  const [open, setOpen] = useState(false);
  const [items, setItems] = useState([]);
  const ref = useRef(null);
  const toggle = async () => {
    const next = !open;
    setOpen(next);
    if (next) {
      const { data } = await api.get("/me/notifications");
      setItems(data.items);
    }
  };
  const markRead = async () => {
    await api.post("/me/notifications/read");
    setItems((x) => x.map((i) => ({ ...i, read: true })));
    load();
  };
  useEffect(() => {
    const h = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("click", h);
    return () => document.removeEventListener("click", h);
  }, []);
  return (
    <div className="notifications-root" ref={ref}>
      <button aria-expanded={open} aria-label="Ver notificaciones" className="notify-btn" onClick={toggle} data-testid="notifications-toggle-btn">
        🔔{d?.unread > 0 && <i className="unread-dot" data-testid="unread-dot" />}
      </button>
      <div className={`notify-panel ${open ? "open" : ""}`} data-testid="notifications-panel">
        <div className="notify-actions"><strong>🔔 Notificaciones</strong><button className="text-link" onClick={markRead} data-testid="notifications-mark-read-btn">Marcar leídas</button></div>
        <div className="list" style={{ marginTop: 8 }}>
          {items.length === 0 && <div className="tiny muted">No tienes notificaciones todavía.</div>}
          {items.map((n) => (
            <div key={n.id} className={`notification ${n.read ? "" : "unread"}`}><b>{n.title}</b>{n.body && <span className="muted">{n.body}</span>}<br /><small>{dateTime(n.at)} · {n.read ? "leída" : "no leída"}</small></div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default function Shell({ view, children }) {
  const nav = useNavigate();
  const { user, logout, config } = useAuth();
  const go = (v) => { nav(`/panel/${v}`); window.scrollTo({ top: 0, behavior: "smooth" }); };
  const initials = (user?.name || "CC").split(" ").map((p) => p[0]).join("").slice(0, 2).toUpperCase();
  return (
    <div className="app-root">
      <div className="app">
        <aside className="side">
          <BrandMark />
          <nav className="nav" data-testid="sidebar-nav">
            {NAV.map(([k, ico, label]) => (
              <button key={k} className={view === k ? "active" : ""} onClick={() => go(k)} data-testid={`nav-${k}`}><span className="ico">{ico}</span>{label}</button>
            ))}
            {user?.role === "admin" && <button onClick={() => nav("/admin")} data-testid="nav-admin"><span className="ico">🛡️</span>Administrador</button>}
          </nav>
          <div className="side-note">
            <strong>✅ Programa activo</strong>
            <p>Recompensas sujetas a las condiciones publicadas.</p>
            <p><a href={wa()} rel="noopener noreferrer" target="_blank" data-testid="sidebar-whatsapp-link">📲 Soporte: {WA_DISPLAY}</a></p>
          </div>
          <div className="tagline">Una experiencia clara, segura y transparente.</div>
        </aside>
        <main className="main">
          <header className="top">
            <img className="top-logo" src={config.logo_url || "/logo.png"} alt={config.brand_name} data-testid="top-logo" />
            <div><div className="eyebrow">PANEL DE RECOMPENSAS · PROGRAMA ACTIVO</div><div className="muted tiny" data-testid="date-label">{todayLabel()}</div></div>
            <div className="right">
              <a className="header-help" href={wa()} rel="noopener noreferrer" target="_blank" data-testid="header-whatsapp-link">💬 Soporte WhatsApp</a>
              <Notifications />
              <span className="small-pill mode-pill-demo" data-testid="mode-pill">✅ Programa activo</span>
              <span className="profile-chip">
                <button className="avatar" onClick={() => go("perfil")} aria-label="Mi perfil" data-testid="profile-avatar-btn">{initials}</button>
                <span className="profile-person" data-testid="profile-name">{user?.name}</span>
                <button type="button" className="signout" onClick={logout} aria-label="Cerrar sesión" data-testid="logout-btn">Salir ↗</button>
              </span>
            </div>
          </header>
          {children}
          <footer className="section-foot">
            {config.brand_name} · Plataforma de recompensas por actividades. Nunca te pediremos pagos, claves privadas ni frases semilla.
            <LegalLinks />
            <p><a className="wa-btn" href={wa("Hola, necesito soporte")} rel="noopener noreferrer" target="_blank" data-testid="footer-whatsapp-btn">💬 Contactar con soporte: {WA_DISPLAY}</a></p>
          </footer>
        </main>
      </div>
      <nav className="mobile-nav" data-testid="mobile-nav">
        {NAV.map(([k, ico, label]) => (
          <button key={k} className={view === k ? "active" : ""} onClick={() => go(k)} data-testid={`mobile-nav-${k}`}><span>{ico}</span>{label}</button>
        ))}
        {user?.role === "admin" && <button onClick={() => nav("/admin")} data-testid="mobile-nav-admin"><span>🛡️</span>Admin</button>}
      </nav>
      <WaFloat />
    </div>
  );
}
